import { makeSelectors } from '@utils/css';

const modifiers = makeSelectors({
  footerHasColumns: "_61f1gjwoo0"
});
const wrapper = "_61w9qjfsh";
const svg = "_61sfq5zc2";
const content = "_61c8qe81v";
const logo = "_61lccz5me";
const logoWrapper = "_61l9nb3kb";
const columnsWrapper = "_61czlvuvz";
const navigation = "_61n1ri828";
const navItem = "_61nz0s3vn";
const publisherLogoWrapper = "_61plg46ah";
const publisherLogo = "_61pjrb4kb";

export { columnsWrapper, content, logo, logoWrapper, modifiers, navItem, navigation, publisherLogo, publisherLogoWrapper, svg, wrapper };
import "./footer.style.linaria.module.css";
//# sourceMappingURL=footer.style.js.map
